export default __webpack_public_path__ + "static/lalibrairie-j-desktop@2x-9bd3110518b08fc3bd2422a216bdffc3.jpg";